import { render, staticRenderFns } from "./DialogManageBatch.vue?vue&type=template&id=3f0c7a9a&scoped=true&"
import script from "./DialogManageBatch.vue?vue&type=script&lang=js&"
export * from "./DialogManageBatch.vue?vue&type=script&lang=js&"
import style0 from "./DialogManageBatch.vue?vue&type=style&index=0&id=3f0c7a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0c7a9a",
  null
  
)

export default component.exports